import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_GENERATE_INVOICE_DOCUMENT_LOADING = 'POST_GENERATE_INVOICE_DOCUMENT_LOADING';
export const POST_GENERATE_INVOICE_DOCUMENT_RESET = 'POST_GENERATE_INVOICE_DOCUMENT_RESET';
export const POST_GENERATE_INVOICE_DOCUMENT_SUCCESS = 'POST_GENERATE_INVOICE_DOCUMENT_SUCCESS';
export const POST_GENERATE_INVOICE_DOCUMENT_REJECT = 'POST_GENERATE_INVOICE_DOCUMENT_REJECT';

//* ACTIONS ------------------------------------------------
export const postGenerateInvoiceDocumentReset = () => ({ type: POST_GENERATE_INVOICE_DOCUMENT_RESET });
export const postGenerateInvoiceDocumentLoading = () => ({ type: POST_GENERATE_INVOICE_DOCUMENT_LOADING });
export const postGenerateInvoiceDocumentSuccess = (payload) => ({ type: POST_GENERATE_INVOICE_DOCUMENT_SUCCESS, payload });
export const postGenerateInvoiceDocumentReject = (payload) => ({ type: POST_GENERATE_INVOICE_DOCUMENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postGenerateInvoiceDocumentRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
    }, getState);
    return request(`/ClientesBillingTracking/web/AddClientesBillingToOdoo/${data}`, options);
};